export default __webpack_public_path__ + "static/media/icon1.d1a4eaf5.png";